export default __webpack_public_path__ + "static/media/edit.82ac9264.svg";